import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Logo";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setMsg({ err: true, text: "As senhas não conferem" });
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password: pw });
      setMsg({ err: false, text: "Senha redefinida com sucesso. Faça login." });
    } catch (err) {
      setMsg({ err: true, text: errMsg(err) });
    }
  };

  return (
    <div className="min-h-screen grid place-items-center mat-texture p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl p-8 space-y-4" data-testid="reset-form">
        <Logo dark={false} />
        <h2 className="text-3xl font-extrabold uppercase">Nova senha</h2>
        <Field label="Nova senha (mín. 8 caracteres)"><Input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></Field>
        <Field label="Confirmar senha"><Input type="password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" /></Field>
        {msg && <div className={`text-sm rounded-md px-3 py-2 ${msg.err ? "bg-red-50 text-red-700" : "bg-emerald-50 text-emerald-700"}`} data-testid="reset-message">{msg.text}</div>}
        <Button type="submit" className="w-full bg-red-600 hover:bg-red-700" data-testid="reset-submit-btn">Salvar</Button>
        <Link to="/login" className="block text-sm text-slate-500 hover:text-red-600">Ir para o login</Link>
      </form>
    </div>
  );
}
